<template lang="html">
	<form class="form-ui column default-form-ui" novalidate>
		<div class="title">
			Actions
		</div>
		<div class="ctn-docs row">
			<div class="ctn-doc">
				<div class="ctn-actions row">
					<div class="btn btn-red ctn-icon" :class="{'btn-disabled': !canCancel}" @click="cancelSubscription()">
						Annuler l'abonnement
					</div>
				</div>
			</div>
		</div>
	</form>
</template>

<script>

export default {
	props: ['subscription'],
	name: 'EditActions',
	components: {
	},
	data () {
		return {
			canCancel: false
		}
	},
	mounted () {
		this.canCancel = this.subscription.is_enabled
	},
	methods: {
		cancelSubscription () {
			if (!this.canCancel) {
				return
			}

			this.$swal.fire({
				title: 'Etes-vous sûr ?',
				text: 'L\'abonnement du client sera annulé et les paiements arrêtés.',
				icon: 'warning',
				confirmButtonColor: '#ff4052',
				showCancelButton: true,
				confirmButtonText: 'confirmer',
				cancelButtonText: 'Annuler'
			}).then((result) => {
				if (result.value) {
					this.processCancelSubscription()
				}
			})
		},

		processCancelSubscription () {
			this.$store.dispatch('cancelSubscription', this.subscription)
			.then((result) => {
				this.canCancel = false
				this.$notify({
					type: 'success',
					group: 'default',
					title: 'L\'abonnement a bien été annulé',
					text: ''
				})
			}).catch((e) => {
				this.$notify({
					type: 'error',
					group: 'default',
					title: 'Une erreur est survenue',
					text: e.message
				})
			})
		}
	}
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// Actions.vue?6c72f6fc